<div matDialogTitle class="dialog-header">
  <h1 class="dialog-title">{{data.title}}</h1>
  <button mat-icon-button class="close-button" [mat-dialog-close]="false" aria-label="Fechar diálogo">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <ngx-datatable class="material ml-0 mr-0" [rows]="baixa" [headerHeight]="50" [footerHeight]="50"
    [messages]="{emptyMessage:'Nenhuma baixa encontrada'}"  [limit]="10" [rowHeight]="50">
  
    <ngx-datatable-column name="#" [width]="25">
      <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <strong>{{ rowIndex+1 }}</strong>
      </ng-template>
    </ngx-datatable-column>
   
    <ngx-datatable-column name="C/C" [flexGrow]="1" [width]="150">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.financRpLctoBaixa.ccPadrao?.id }}{{ row.financRpLctoBaixa.ccPadrao?.numeroConta ? ' - ' + row.financRpLctoBaixa.ccPadrao.numeroConta : '' }}
      </ng-template>
    </ngx-datatable-column>
  
    <ngx-datatable-column name="Controle C/C" [flexGrow]="1" [width]="90">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{row.financRpLctoBaixa?.financCcMovto?.controle}}
      </ng-template>
    </ngx-datatable-column>
  
    <ngx-datatable-column name="Data Pgto" [flexGrow]="1" [width]="100">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row.dataPgto | date: 'dd/MM/yyyy' }}
      </ng-template>
    </ngx-datatable-column>
  
  
    <!-- <ngx-datatable-column name="DOCTO" [flexGrow]="1" [width]="200">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{row.docto}}
      </ng-template>
    </ngx-datatable-column> -->
  
    <ngx-datatable-column name="Transação" [flexGrow]="1" [width]="220">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.fatTransacaoId.toString().padStart(5, '0') }} - 
        {{ row.financRpLctoBaixa.fatTransacao.descricao?.length > 15 ? (row.financRpLctoBaixa.fatTransacao.descricao | slice:0:15) + '...' : row.financRpLctoBaixa.fatTransacao.descricao }}
      </ng-template>
    </ngx-datatable-column>
  
    <ngx-datatable-column name="Histórico" [flexGrow]="1" [width]="420">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="historico-cell" title="{{row.historico}}">
          {{ row.historico?.length > 50 ? (row.historico | slice:0:50) + '...' : row.historico }}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <style>
      .historico-cell {
        overflow-x: auto;
        white-space: nowrap;
        max-width: 300px;
        display: block;
      }
    </style>
  
    <ngx-datatable-column name="Vlr.Recebido" [flexGrow]="1" [width]="90" [prop]="'valorRecebido'" [cellClass]="'text-right'">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span class="text-right">{{ row.valorRecebido | number:'1.2-2' }}</span>
      </ng-template>
    </ngx-datatable-column>
    <style>
      .text-right {
        text-align: right;
        display: block;
      }
    </style>
  
  </ngx-datatable>
</div>